import { DOWNLOADFILE, GET } from "../../API/get";
import { POST } from "../../API/post";

export const fetchJobDetails = async (job_id) => {
    const response = await GET(`admin/job/details/${job_id}`);
    return response.status === "Success" ? response : null;
};

export const fetchJobMapDetails = async (job_id) => {
    const response = await GET(`admin/job/map/details/${job_id}`);
    return response.status === "Success" ? response : null;
};

export const fetchJobStatusHistory = async (job_id) => {
    const response = await GET(`job/status/history/${job_id}`);
    return response.status === "Success" ? response : null;
}

export const fetchApproveForAnotherDate = async (approve_for_another_date_job_id) => {
    const response = await GET(`job/approve/for/another/date/${approve_for_another_date_job_id}`);
    return response.status === "Success" ? response : null;
}

export const fetchRescheduleDetails = async (job_id) => {
    const response = await GET(`jobs/${job_id}/reschedule`);
    return response.status === "Success" ? response : null;
}

export const fetchExpressJobDetails = async (job_id) => {
    const response = await GET(`/express-job//${job_id}`);
    return response.status === "Success" ? response : null;
}

export const fetchTradespersonFeeBreakdown = async (job_id) => {
    const response = await GET(`/tradesperson-fee-breakdown/${job_id}`);
    return response.status === "Success" ? response : null;
}

export const jobPaymentRefund = async (payment_id, payment_value) => {
    const response = await POST(`/job/payment/refund`, {
        payment_id : payment_id,
        payment_value : payment_value
    });
    return response.status === "Success" ? response : null;
}

export const downloadInvoice = async (job_id, type) => {
    const response = await DOWNLOADFILE(`v3/jobs/${job_id}/invoice/${type}?download=true`);
    return response?.status === "Success" ? response : null;
}

export const downloadJobsheet = async (job_id, type) => {
    const response = await DOWNLOADFILE(`v3/jobs/${job_id}/jobsheet?download=true`);
    return response?.status === "Success" ? response : null;
}